/** Inline `<style>` bodies extracted from SalesOrderDetails for readability. */

export const SALES_ORDER_DETAILS_PAGE_HEADER_CSS = `
  .page-header{
    padding-bottom:14px;
    border-bottom:1px solid #edf1f5;
  }
  .btn-white { background:#fff; }
  .dropdown-toggle.no-caret::after { display:none; } /* 'Actions …' look */

  /* Helpers to prevent badge/title overflow on small screens */
  .minw-0 { min-width:0; }

  /* Mobile + tablet tweaks */
  @media (max-width: 767.98px) {
    .page-header .order-tittle {
      font-size: 1.05rem;  /* slightly smaller */
      line-height: 1.2;
      max-width: 100%;
    }
    .back-btn {
      padding: 6px 10px;
      font-size: 0.9rem;
      line-height: 1;
      border-radius: 8px;
    }
    /* Make Actions button easier to tap and stretch full width */
    .actions-dropdown .dropdown-toggle {
      display: inline-flex;
      justify-content: center;
    }
    .actions-dropdown .dropdown-menu {
      width: 100%;
      max-width: 100%;
    }
  }

  /* Tablet spacing polish */
  @media (min-width: 768px) and (max-width: 1021px) {
    .page-header .order-tittle { font-size: 1.15rem; }
  }
    /* place this at the very end of the file or in a CSS loaded last */
.rdt-desktop { display: block !important; }
.rdt-mobile  { display: none  !important; }

@media (max-width: 1021.98px) {
  .rdt-desktop { display: none !important; }
  .rdt-mobile  { display: block !important; }
}
`;

export const SALES_ORDER_DETAILS_PAYMENT_TXN_CSS = `
  .rounded-4 { border-radius: 16px; }
  .card-header { border-bottom: 1px solid #edf1f5; }
  .icon-chip {
    width: 28px; height: 28px; border-radius: 8px;
    display:inline-flex; align-items:center; justify-content:center;
    font-size: 16px;
  }
  .chip-blue { background:#EEF5FF; color:#3B82F6; }   /* shipping icon */
  .chip-rose { background:#FEE2E2; color:#DC2626; }   /* payment icon */
  .fs-14 { font-size: 14px; }
  .details-label { font-weight:600; color:#111827; margin-bottom: 2px; }
  .details-value { color:#111827; }
   .txn-scroll{
    max-height: 320px;            /* adjust height as you like */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    background: #fff;
  }
  .txn-sep{
    border: 0;
    border-top: 1px solid #eef2f6; /* soft divider */
  }
`;

export const SALES_ORDER_DETAILS_ORDER_LOG_CSS = `
        .rounded-4 { border-radius: 16px; }
        .card-header { border-bottom: 1px solid #edf1f5; }

        .ol-row {
          padding: 14px 20px;
          font-size: 14px;
          min-height: 56px;            /* comfy row height like your ref */
        }
        .fw-500 { font-weight: 500; }
        .ol-time { font-size: 12px; color:#6b7280; font-weight: 600; }

        /* marker column */
        .ol-marker {
          width: 34px;                 /* room for bubble + connector */
          flex: 0 0 34px;
          position: relative;
          display: flex;
          justify-content: center;
        }
        /* pastel bubble container (uses CSS vars) */
        .ol-bubble {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: var(--bubble, #eef2ff);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        /* small dot with soft halo (uses CSS vars) */
        .ol-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: var(--dot, #3b82f6);
          box-shadow: 0 0 0 6px var(--halo, rgba(59,130,246,.18));
        }
        /* connector to the next row */
        .ol-connector {
          position: absolute;
          top: 28px;                   /* just under bubble */
          left: 50%;
          transform: translateX(-50%);
          width: 2px;
          bottom: -12px;               /* extend a tad past the row to bridge gaps */
          background: #e5e7eb;
          opacity: .9;
          height: 30px;
        }
        /* keep inline chips aligned */
        .ol-content > * { display: inline-flex; }

        /* put in a global css file or inside your InvoiceDocument <style> */
.pdf-export,
.pdf-export *{
  font-variant-ligatures: none !important;
  font-feature-settings: "liga" 0, "clig" 0, "calt" 0 !important;
  font-kerning: none !important;
  letter-spacing: normal !important;         /* avoid sub-pixel spacing */
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  text-rendering: geometricPrecision !important;
}

      `;
